// Copyright (c) 2022 Deere & Company

import ClosingAccountSearchDealer from './closing-account-search-account';
import t from 'tcomb';

const ClosingAccountChanges = t.list(ClosingAccountSearchDealer, 'ClosingAccountChanges');

export const getDefaultState = () => new ClosingAccountChanges([]);

export default ClosingAccountChanges;



// WEBPACK FOOTER //
// ./src/tcsm/wip/state/closing-account.js